"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFacilitiesList = exports.StyledFacilitiesItem = exports.StyledFacilitiesHeader = exports.NO_INFO_TEXT = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _FacilitiesItem = _interopRequireDefault(require("../FacilitiesItem"));
var _hotel = require("../../proptypes/hotel");
var _HotelFacilitiesPopup = _interopRequireDefault(require("../HotelFacilitiesPopup/HotelFacilitiesPopup"));
var _excluded = ["facilities", "description", "hotelFacilities", "isMobile", "inCard"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NO_INFO_TEXT = exports.NO_INFO_TEXT = _localization.i18n.t('hotel.room.noInfo');
var HotelRoomFacilities = function HotelRoomFacilities(_ref) {
  var facilities = _ref.facilities,
    description = _ref.description,
    hotelFacilities = _ref.hotelFacilities,
    isMobile = _ref.isMobile,
    inCard = _ref.inCard,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var disabled = rest.disabled,
    className = rest.className;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var hasFacilities = !(0, _isEmpty2["default"])(facilities);
  var noInfo = !(description || hasFacilities);
  return /*#__PURE__*/_react["default"].createElement("div", {
    disabled: disabled,
    className: className
  }, (description || noInfo) && /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    noInfo: noInfo
  }, noInfo ? NO_INFO_TEXT : description), hasFacilities && /*#__PURE__*/_react["default"].createElement(FacilitiesContainer, null, /*#__PURE__*/_react["default"].createElement(StyledFacilitiesHeader, null, "".concat(t('hotel.room.inRoom'), ":")), /*#__PURE__*/_react["default"].createElement(StyledFacilitiesList, {
    $isMobile: isMobile
  }, facilities.map(function (_ref2) {
    var name = _ref2.name,
      type = _ref2.group_identifier;
    return name ? /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
      key: name,
      showCheck: true,
      icon: type,
      inCard: inCard
    }, name) : null;
  })), !(0, _isEmpty2["default"])(hotelFacilities) && /*#__PURE__*/_react["default"].createElement(_HotelFacilitiesPopup["default"], {
    items: hotelFacilities,
    isMobile: isMobile
  })));
};
var StyledFacilitiesList = exports.StyledFacilitiesList = _styledComponents["default"].ul.withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesList",
  componentId: "sc-4m6iju-0"
})(["display:grid;margin-top:3px;", " gap:.25em .5em;grid-template-columns:1fr 1fr;"], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return !$isMobile && (0, _styledComponents.css)(["width:230px;column-count:2;"]);
});
var StyledFacilitiesItem = exports.StyledFacilitiesItem = (0, _styledComponents["default"])(_FacilitiesItem["default"]).withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesItem",
  componentId: "sc-4m6iju-1"
})(["", ";color:", ";flex-basis:50%;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.blackLight;
});
var StyledFacilitiesHeader = exports.StyledFacilitiesHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__StyledFacilitiesHeader",
  componentId: "sc-4m6iju-2"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:500;line-height:16px;"]);
var FacilitiesContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__FacilitiesContainer",
  componentId: "sc-4m6iju-3"
})(["display:flex;flex-direction:column;gap:0.5em;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomFacilities__StyledDescription",
  componentId: "sc-4m6iju-4"
})(["font-weight:400;font-size:14px;line-height:16px;color:var(--black);margin-bottom:0.5em;"]);
HotelRoomFacilities.propTypes = {
  facilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  description: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool
};
HotelRoomFacilities.defaultProps = {
  facilities: null,
  hotelFacilities: null,
  description: null,
  isMobile: false
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelRoomFacilities);